export const IFRAME_RESIZER_CHILD_SCRIPT =
  "https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.6/iframeResizer.contentWindow.min.js";

export const RECAPTCHA_SCRIPT = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
